<template>
    <div>
		<div class="dropdown-menu remove-style" aria-labelledby="dropdownMenuButton">
			<a class="dropdown-item" style="cursor:pointer" href="javascript:void(0)" :disabled="selectedProducts.length < 1" @click="selectedBulkAction='Delete Product';productActionChanged()">Delete Product</a>
			<a class="dropdown-item" style="cursor:pointer" href="javascript:void(0)" :disabled="selectedProducts.length < 1" @click="selectedBulkAction='Hide Product';productActionChanged()">{{ $store.state.showHidden? 'Unhide' : 'Hide' }} Product</a>
			<a class="dropdown-item" style="cursor:pointer" :disabled="(selectedProducts.length <1)" @click="selectedBulkAction='Add Tag';productActionChanged()">Add Tag</a>
		</div>
		
		<div v-if = "(showCannotDel && selectedProducts.length)"><p style = "color : red"> {{'Cannot Delete ' + cannotDelArray + ' as part of campaign'}}</p>
		</div>
		 <ProductListDeleteConfirmModal
		 	heading="Delete Product(s)"
		 	@deleteSelectedProducts="deleteSelectedProducts"
			@closeDeleteConfirmModal="closeDeleteConfirmModal"
		 ></ProductListDeleteConfirmModal>
		 <ProductListHideConfirmModal
		 	heading="Hide Product(s)"
		 	@hideSelectedProducts="hideSelectedProducts"
			@closeHideConfirmModal="closeHideConfirmModal"
		 ></ProductListHideConfirmModal>
		 <CannotDeletePopUp
			 headerMsg = "Delete"
			 :deleteMessage = "msg"
			 />
		<CannotHidePopUp
			headerMsg = "Hide"
			:hideMessage = "msg"
		/>
		  <AddTags
		  		@closeModal = "closeTagModal"
		  />
    </div>
</template>

<script>
import ProductListDeleteConfirmModal from '@/components/product/ProductListDeleteConfirmModal'
import ProductListHideConfirmModal from '@/components/product/ProductListHideConfirmModal';
import AddTags from '@/components/product/AddTags'
import CannotDeletePopUp from '../product/CannotDeletePopUp.vue'
import CannotHidePopUp from '@/components/product/CannotHidePopUp'
import XLSX from "xlsx";

import ProductListGridFooter from '@/components/product/ProductListGridFooter'

export default {
    name: 'ProductListAction',
    data() {
        return {
            selectedBulkAction: 'Action',
			showCannotDel : false,
			cannotDelArray : [],
			cannotHideArray : [],
			msg : ''
        }
    },
	components : {
		ProductListDeleteConfirmModal,
		CannotDeletePopUp,
		AddTags,
		ProductListGridFooter,
		ProductListHideConfirmModal,
		CannotHidePopUp
	},
    computed: {
        selectedProducts: {
            set(val) {
				this.showCannotDel = false
				this.cannotDelArray = []
				this.cannotHideArray = []
                this.$store.state.product.selectedProducts = val
            },
            get() {
                return this.$store.state.product.selectedProducts;
            }
        },
		selectedVendorProduct: {
			set(val) {
				 this.$store.state.selectedVendorProduct = val
			},
			get() {
				 return this.$store.state.selectedVendorProduct;
			}
		},
		selectedBrandProduct: {
			set(val) {
				 this.$store.state.selectedBrandProduct = val
			},
			get() {
				 return this.$store.state.selectedBrandProduct;
			}
		},
		actionSelectionControl: {
			set(val) {
				this.$store.state.product.actionSelectionControl = val
			},
			get() {
				return this.$store.state.product.actionSelectionControl
			}
		},
    },
    methods: {
        // navigateToAddProduct() {
        //     this.$router.push({path:'/addEditProduct'})
        // },
        productActionChanged() {
            if (this.selectedBulkAction.toLowerCase() == 'add to campaign') {
                if (this.$store.state.product.selectedProducts.length > 0) {
                    let ids = this.selectedProducts.map((element) => {
                        return element.id
                    })
                    this.$router.push({path:'addToCampaign/' + ids.join('+') + '/'+ this.selectedVendorProduct + '/' + this.selectedBrandProduct})
                    // this.$router.push('addToCampaign')
                    this.selectedBulkAction = 'Action'
                    return
                }
            }
            else if (this.selectedBulkAction.toLowerCase() == 'create a campaign') {
                if (this.$store.state.product.selectedProducts.length > 0) {
                    let ids = this.selectedProducts.map((element) => {
                        return element.asin
                    })
                    this.$router.push({path:'addEditCampaignProduct/' + ids.join('+')})
                    // this.$router.push('addEditCampaign')
                    this.selectedBulkAction = 'Action'
                    return
                }
            }
			else if(this.selectedBulkAction.toLowerCase() == 'delete product'){
				this.selectedProducts.forEach((res) => {
					if(res.count>0){
						this.cannotDelArray.push(res.asin)
					}
				})
				if(this.cannotDelArray.length){
					//
					this.$store.commit('product/setSelectedProduct',[]);
				//	this.$store.state.product.selectedProducts = [];
					this.cannotDelArray = this.cannotDelArray.join(',');
					this.msg = " Can not delete: " + this.cannotDelArray;
					this.$store.commit('product/setActionSelectionControl', false);
					this.$store.commit('product/setSelectedProduct', []);
					this.selectedBulkAction = 'Action'

					$('#cannotDelete').modal('show');
					this.cannotDelArray = []
				}
				else{
					$('#confirmDeleteProduct').modal('show')
				}
			}
			else if(this.selectedBulkAction.toLowerCase() == 'hide product'){
				this.selectedProducts.forEach((res) => {
					if(res.count>0){
						this.cannotHideArray.push(res.asin)
					}
				})
				if(this.cannotHideArray.length){
					//
					this.$store.commit('product/setSelectedProduct',[]);
				//	this.$store.state.product.selectedProducts = [];
					this.cannotHideArray = this.cannotHideArray.join(',');
					this.msg = " Can not hide: " + this.cannotHideArray;
					this.$store.commit('product/setActionSelectionControl', false);
					this.$store.commit('product/setSelectedProduct', []);
					this.selectedBulkAction = 'Action'

					$('#cannotHide').modal('show');
					this.cannotDelArray = []
				}
				else{
					$('#confirmHideProduct').modal('show')
				}
			}
			else if(this.selectedBulkAction.toLowerCase() == 'add tag'){
				$("#taggableProduct").modal('show');
			}
			else if(this.selectedBulkAction == 'Define Guardrail'){
				let path ='/AddGuardrail/product'
				this.$router.push({ path: path});
			}
			else if(this.selectedBulkAction == 'Export Excel'){
				this.exportExcel()
			}
            // this.selectedBulkAction = 'Action'
        },
		closeDeleteConfirmModal(){
			this.$store.commit('product/setActionSelectionControl', false);
			this.$store.commit('product/setSelectedProduct', []);
			this.selectedBulkAction = 'Action'
			$('#confirmDeleteProduct').modal('hide')
		},
		closeHideConfirmModal(){
			this.$store.commit('product/setActionSelectionControl', false);
			this.$store.commit('product/setSelectedProduct', []);
			this.selectedBulkAction = 'Action'
			$('#confirmHideProduct').modal('hide')
		},
		deleteSelectedProducts() {
			let vm = this


				this.showCannotDel = false
				this.cannotDelArray = [];
				let productIds = this.selectedProducts.map((element) => {
					return element.id
				})
			//    productIds = productIds.join(',')
				this.$store.dispatch('product/deleteMultipleProducts', { data: { productIds: productIds, isSeller: this.$store.state.isSeller }, callback:() => {
					//
					vm.selectedProducts = []
					vm.$store.dispatch('product/getAllProducts')
					$('#confirmDeleteProduct').modal('hide')
				}})

		},
		hideSelectedProducts() {
			let vm = this
			console.log("HIDING SELECTED")

			this.showCannotHide = false
			this.cannotHideArray = [];
			let productIds = this.selectedProducts.map((element) => {
				return element.id
			})

			console.log("HIDE PRODUCTS: ", productIds)
			//    productIds = productIds.join(',')
			this.$store.dispatch('product/hideProducts', { data: { productIds: productIds, isSeller: this.$store.state.isSeller, hidden: !this.$store.state.showHidden }, callback:() => {
				//
				// vm.selectedProducts = []
				vm.$store.dispatch('product/getAllProducts')
				$('#confirmHideProduct').modal('hide')
			}})

		},
		closeTagModal(type){

			$('#taggableProduct').modal('hide');
			this.selectedBulkAction =  'Action';
			this.actionSelectionControl = false;
			if(!type){
				this.$store.dispatch('product/getAllProducts')
			//	this.$refs["productAdvanceFilter"].getData();
			}
		},
		// exportExcel(){
		// 	let payload = {
		// 		isWithoutPagination:true,
		// 		q: this.$store.state.searchFilterString,
		// 		ams_profile_id: this.$store.state.selectedBrandProduct,
		// 		vendor: this.$store.state.selectedVendorProduct,
		// 		sort: this.$store.state.selectedSortOrder
		// 	}
		//
		// 	this.$store.dispatch("product/getAllProducts", payload).then((res) => {
		// 		let data = []
		// 		let vm = this;
		// 		let list = res
		// 		list.forEach(resp => {
		// 			let arr = {
		// 				vendor:resp.vendor_name ? resp.vendor_name : '',
		// 				brand:resp.brand ? resp.brand : '',
		// 				product_title:resp.product_title ? resp.product_title : '',
		// 				asin:resp.asin ? resp.asin : '',
		// 				category:resp.category ? resp.category : '',
		// 				style:resp.style ? resp.style : ''
		// 			}
		// 			data.push(arr);
		// 		})
		//
		// 		const wb = XLSX.utils.book_new();
		// 		var workbook = XLSX.utils.json_to_sheet(data);
		//
		//
		// 		XLSX.utils.book_append_sheet(
		// 			wb,
		// 			workbook,
		// 			"excel_data.csv"
		// 		);
		//
		//
		//
		// //	var wbout = XLSX.writeFile(wb,'test.csv',{raw:true});
		//
		//
		//
		// 		let safariAgent = navigator.userAgent.indexOf("Safari") > -1;
		// 		let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1;
		//
		//
		// 		if(safariAgent && !chromeAgent){
		// 			var wbout = XLSX.write(wb , {bookType:'csv',  type: 'binary'});
		// 			var blob = new Blob([vm.s2ab(wbout)], { type: 'application/octet-stream"' });
		// 			var link = document.createElement('a');
		// 			link.href = URL.createObjectURL(blob);
		// 			link.download = "asins.csv";
		// 			link.target = "_blank";
		// 			link.click();
		// 		}
		// 		else{
		// 			var wbout = XLSX.write(wb , {bookType:'csv',  type: 'binary'});
		// 			var blob = new Blob([vm.s2ab(wbout)], { type: 'text/csv;charset=utf-8;' });
		// 			let url = window.URL.createObjectURL(blob);
		// 			var myWindow = window.open("", "_blank");
		// 			myWindow.focus()
		// 			let link = myWindow.document.createElement('a');
		// 			link.href = url;
		// 			link.download = "asins.csv";
		//
		// 			link.click();
		//
		// 			myWindow.focus()
		// 			//myWindow.close()
		// 		}
		//
		//
		// 		this.selectedBulkAction ='Action'
		// 		// var hiddenElement = document.createElement('a');
		// 		// hiddenElement.href = url;
		// 		// hiddenElement.target = '_blank';
		// 		// hiddenElement.download = 'test.csv';
		// 		// document.getElementById('container').appendChild(hiddenElement);
		// 		// hiddenElement.click();
		//
		// 		//w.focus()
		//
		// 	});
		//
		// },
		s2ab(s) {
			var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
			var view = new Uint8Array(buf);  //create uint8array as viewer
			for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
			return buf;
		}
    }
}
</script>

<style lang="scss">

</style>
